import { getNumericParam, setParamIfDefined, setParamIfUndefined, toUrl } from "../utils.js";
export const parse = url => {
  const parsedUrl = toUrl(url);
  const fit = parsedUrl.searchParams.get("fit") || undefined;
  const width = getNumericParam(parsedUrl, "w");
  const height = getNumericParam(parsedUrl, "h");
  const quality = getNumericParam(parsedUrl, "q");
  const format = parsedUrl.searchParams.get("fm") || undefined;
  parsedUrl.search = "";
  return {
    width,
    height,
    format,
    base: parsedUrl.toString(),
    params: {
      fit,
      quality
    },
    cdn: "kontent.ai"
  };
};
export const transform = _ref => {
  let {
    url: originalUrl,
    width,
    height,
    format
  } = _ref;
  const url = toUrl(originalUrl);
  setParamIfDefined(url, "w", width, true, true);
  setParamIfDefined(url, "h", height, true, true);
  setParamIfDefined(url, "fm", format, true);
  if (width && height) {
    setParamIfUndefined(url, "fit", "crop");
  }
  return url;
};